import styled from 'styled-components';
import {bpXl} from "../../assets/styledAssets/vars";

export const SlidingRight = styled.div`
  position: fixed;
  top: 100vh;
  bottom:-100vh;
  left:0;
  right:0;
  transition:.3s;
  max-width:100%;
  z-index:2;
  &.active{
    top:7rem;
    bottom:0;
  }
  @media(min-width:${bpXl}){
    top:0;
    bottom:0;
    width:100%;
    max-width:40vw;
    right:-40vw;
    left:auto;
    &.active{
      right:0;
      top:0;
    }
  }
`;